import type { Guide } from "../../../../types";
import type { PageLoad } from "./$types";
import { redirect } from "@sveltejs/kit";
import { parseId } from "../../../../params/slug";
import { guidesPath, homePath } from "../../../../support/links";

export const load: PageLoad = async function ({ params, parent }) {
  const { guides, settings } = await parent();

  const id = parseId(params.id);

  const guide = guides.find((g: Guide) => g.id == id);

  let returnRoute;

  if (guides.length > 1) {
    returnRoute = guidesPath({ start: guide?.id });
  } else if (settings.showHome) {
    returnRoute = homePath();
  } else {
    returnRoute = "/";
  }

  if (guide == null) {
    redirect(302, returnRoute);
  }

  return {
    guide: guide as Guide,
    returnRoute: returnRoute,
    pageBackgroundColor: "#eae9e1",
    pageDescription: guide.description,
    pageTheme: "#eae9e1",
    pageTitle: guide.title,
    showNav: false
  };
};
